import { PrimaryLoadingIndicator, LoaderSize } from "@normasteaching/norma-ui";

export function FullPageLoadingWithMessage({
  mainMessage,
  secondaryMessage,
}: {
  mainMessage: string;
  secondaryMessage: string;
}) {
  return (
    <div
      className={
        "min-h-screen min-w-screen flex flex-col items-center justify-center"
      }
    >
      <PrimaryLoadingIndicator size={LoaderSize.Large} />
      <h2 className="text-xl font-bold text-gray-900">{mainMessage}</h2>
      <p className="text-gray-600">{secondaryMessage}</p>
    </div>
  );
}
